
import React, { useEffect, useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import Header from "../Home/Header";
import { useNavigate } from "react-router-dom";

const QRDisplay = () => {
const navigate = useNavigate();
    useEffect(() => {
              const role = sessionStorage.getItem("userRole");
              if (!role) navigate("/");
            }, [navigate]);

  const links = [
    {
      label: "Register Member [Kesbawe Branch]",
      url: "https://www.lifefitnesspartner.com/registration-member",
    },
    {
          label: "Register Member [Werahera Branch]",
          url: "https://www.lifefitnesspartner.com/registration-member_WB",
        },
    {
      label: "Mark Attendance [Kesbawe Branch]",
      url: "https://www.lifefitnesspartner.com/mark-attendance",
    },
    {
          label: "Mark Attendance [Werahera Branch]",
          url: "https://www.lifefitnesspartner.com/mark-attendance_WB",
        },
  ];



  return (

  <div className="dashboard">
    <Header/>

    <div className="qr-container">
      <h2>Scan QR Code</h2>

      <div className="qr-list">
        {links.map((link, index) => (
          <div key={index} className="qr-item">
            <QRCodeCanvas value={link.url} size={200} />
            <p>{link.label}</p>
          </div>
        ))}
      </div>

    </div>
  </div>

  );
};

export default QRDisplay;
